import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import ApplianceInstallationSection from "@/components/ApplianceInstallationSection";
import Services from "@/components/Services";
import PricingSection from "@/components/PricingSection";
import ContactSection from "@/components/ContactSection";
import LanguageDialog from "@/components/LanguageDialog";
import Testimonials from "@/components/Testimonials";
import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";

const Index = () => {
  const { setLanguage, language } = useLanguage();

  const handleLanguageSelect = (lang: string) => {
    setLanguage(lang as "en" | "fi");
  };

  // Schema markup for appliance installation service
  const applianceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": language === "en" 
      ? "Dishwasher & Washing Machine Installation" 
      : "Astianpesukoneen ja Pesukoneen Asennus",
    "provider": {
      "@type": "Organization",
      "name": "ServiceMind24",
      "url": "https://servicemind24.lovable.app",
      "telephone": "0931588300"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Helsinki, Finland"
    },
    "offers": {
      "@type": "Offer",
      "price": "79",
      "priceCurrency": "EUR"
    },
    "description": language === "en"
      ? "Expert installation of dishwashers and washing machines with warranty. Professional service, quick booking, and reliable results."
      : "Asiantunteva astianpesukoneiden ja pesukoneiden asennus takuulla. Ammattitaito, nopea varaus ja luotettava tulos."
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <title>
        {language === "en" 
          ? "Dishwasher & Washing Machine Installation Helsinki | ServiceMind24" 
          : "Astianpesukoneen ja Pesukoneen Asennus Helsinki | ServiceMind24"}
      </title>
      <meta 
        name="description" 
        content={language === "en"
          ? "Professional dishwasher and washing machine installation in Helsinki. €79 + VAT. Expert technicians, quick service, warranty included. Book via WhatsApp! Cleaning, moving, plumbing services."
          : "Ammattimainen astianpesukoneen ja pesukoneen asennus Helsingissä. 79€ + ALV. Asiantuntevat asentajat, nopea palvelu, takuu mukana. Varaa WhatsAppilla! Siivous-, muutto-, putkipalvelut."
        } 
      />
      <meta 
        name="keywords" 
        content="dishwasher installation Helsinki, washing machine installation, appliance installation service, kodinkone asennus, astianpesukoneen asennus Helsinki, pesukoneen asennus Suomi, siivouspalvelut Helsinki, muuttopalvelut, pesukoneen asennus, astianpesukoneen asennus, maalauspalvelut, käsityömies Helsinki, putkipalvelut Helsinki, remontointi Helsinki" 
      />
      <meta name="robots" content="index, follow" />
      <meta 
        property="og:title" 
        content={language === "en"
          ? "Dishwasher & Washing Machine Installation Helsinki | ServiceMind24"
          : "Astianpesukoneen ja Pesukoneen Asennus Helsinki | ServiceMind24"
        } 
      />
      <meta 
        property="og:description" 
        content={language === "en"
          ? "Professional appliance installation in Helsinki. €79 + VAT. Expert service with warranty."
          : "Ammattimainen kodinkone asennus Helsingissä. 79€ + ALV. Asiantunteva palvelu takuulla."
        } 
      />
      <meta property="og:type" content="website" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(applianceSchema)}
      </script>
      
      <LanguageDialog onLanguageSelect={handleLanguageSelect} />
      
      <div className="min-h-screen overflow-x-hidden">
        <Header />
        <main className="pt-44 md:pt-20">
          <Hero />
          <ApplianceInstallationSection />
          <AboutSection />
          <PricingSection />
          <Services />
          <Gallery />
          <ContactSection />
          <Testimonials />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
